import { FileSizeType } from '@shared/models/enums/file-size-type'

export const fileSizeFormatter = (
  bites: number | undefined,
  format: FileSizeType
) => {
  if (!bites) {
    return 0
  }
  return bites / format
}
